import { useDispatch } from "react-redux";

import type { SidebarHubTaskItem } from "app/pages/sales-intelligence/sub-modules/onboarding/types/SidebarHub";
import { redirectUserByTask } from "app/pages/sales-intelligence/sub-modules/onboarding/utils/redirectUserByGoal";

function useHandleActionByTask(): (task: SidebarHubTaskItem) => void {
    const dispatch = useDispatch();

    return (onboardingTask: SidebarHubTaskItem) => {
        redirectUserByTask(onboardingTask.taskType, dispatch);
    };
}

export default useHandleActionByTask;
